// src/components/Footer.js - REVISED TO HIDE FOR ADMINS
import React from 'react';
import { InstagramIcon, TikTokIcon, TwitterIcon, YouTubeIcon } from './Icons';
import PartnersSection from './PartnersSection';
// ✨ NEW: Import our useAuth hook
import { useAuth } from '../hooks/useAuth';
import { Link } from 'react-router-dom'; // ✅ NEW: Import Link (navegar)

const socialLinks = [
  { name: 'Instagram', href: 'https://www.instagram.com/escambodigital.com.br', icon: InstagramIcon },
  { name: 'TikTok', href: 'https://www.tiktok.com/@escambodigital', icon: TikTokIcon },
  { name: 'Twitter', href: 'https://twitter.com/escambo_digital', icon: TwitterIcon },
  { name: 'YouTube', href: 'https://www.youtube.com/@escambo.digital', icon: YouTubeIcon },
];

export default function Footer({
  db,
//  user,
//  navigate,
  partners = [],
//  partnersConfig,
   // ✅ FIX: Provide a default value for partnersConfig to prevent crashes.
  partnersConfig = { show: false }, 
  theme = 'light',
  customStyles = {}
}) {
  // ✨ NEW: Get the profile directly from our central hook
  const { profile } = useAuth();
  // ✅ FIX: Add a direct role check at the top of the component.
  // If the user's role is 'admin', render nothing.
  if (profile?.role === 'admin') {
    return null;
  }

  const themes = {
    light: {
      mainSection: 'bg-gray-50 border-gray-200',
      text: 'text-gray-600',
      textSecondary: 'text-gray-500',
      socialHover: 'hover:text-green-600 hover:bg-green-50',
      linkHover: 'hover:text-green-600',
      border: 'border-gray-200'
    },
    dark: {
      mainSection: 'bg-gray-800 border-gray-700',
      text: 'text-gray-300',
      textSecondary: 'text-gray-400',
      socialHover: 'hover:text-green-400 hover:bg-green-900',
      linkHover: 'hover:text-green-400',
      border: 'border-gray-700'
    }
  };

  const currentTheme = themes[theme] || themes.light;

  // The old logic based on screen names is no longer needed.
  // const adminScreens = ['AdminScreen', ...];
  // if (adminScreens.includes(currentScreen)) { ... }

  return (
    <footer className="bg-white mt-auto" style={customStyles.footer}>
      
      {partnersConfig.show && partners && partners.length > 0 && (
        <PartnersSection
          db={db}
          // user={user}
	  //user={user}
          partners={partners}
          title={partnersConfig.title}
          showCarousel={partnersConfig.showCarousel}
          maxVisible={partnersConfig.maxVisible}
          autoRotate={partnersConfig.autoRotate}
          rotateInterval={partnersConfig.rotateInterval}
          className={theme === 'dark' ? 'bg-gray-800 border-gray-700' : ''}
        />
      )}

      <div className={`${currentTheme.mainSection} border-t`} style={customStyles.mainSection}>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start space-y-6 lg:space-y-0">
            {/* Social Links Section */}
            <div className="text-center lg:text-left lg:flex-1">
              <p className={`${currentTheme.text} text-sm sm:text-base font-medium mb-4 sm:mb-6`} style={customStyles.supportText}>
                Gostou do projeto? Ajude-nos a manter a plataforma gratuita. Siga-nos!
              </p>
              <div className="flex justify-center lg:justify-start space-x-4 sm:space-x-6 mb-6 lg:mb-0">
                {socialLinks.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${currentTheme.text} ${currentTheme.socialHover} transition-colors duration-200 p-2 rounded-full focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2`}
                    aria-label={`Seguir no ${item.name}`}
                  >
                    <item.icon className="h-5 w-5 sm:h-6 sm:w-6" />
                  </a>
                ))}
              </div>
            </div>

            {/* Navigation Links Section */}
            <div className="text-center lg:text-right lg:flex-1">
              <div className="space-y-2 sm:space-y-3">
                <div className="flex flex-col sm:flex-row justify-center lg:justify-end space-y-2 sm:space-y-0 sm:space-x-6 mb-4">

{/* CHANGED: Replaced buttons with Link components */}
                                    <Link to="/home" className={`${currentTheme.text} ${currentTheme.linkHover} hover:underline text-sm sm:text-base`}>
                                        Início
                                    </Link>
                                  <Link to="/signup" className={`${currentTheme.text} ${currentTheme.linkHover} hover:underline text-sm sm:text-base`}>
                                        Cadastrar
                                    </Link> 
                                </div>
                                <div className="flex flex-col sm:flex-row justify-center lg:justify-end space-y-2 sm:space-y-0 sm:space-x-6 mb-4">
                                    <Link to="/terms" className={`${currentTheme.text} ${currentTheme.linkHover} hover:underline text-sm sm:text-base`}>
                                        Termos de Uso 
                                    </Link>
                                    <Link to="/privacy" className={`${currentTheme.text} ${currentTheme.linkHover} hover:underline text-sm sm:text-base`}>
                                         Política de Privacidade
                                    </Link>
                                    <Link to="/seguranca-infantil" className={`${currentTheme.text} ${currentTheme.linkHover} hover:underline text-sm sm:text-base`}>
                                         Segurança Infantil
                                    </Link>
{/* CHANGED: Replaced buttons with Link components */}
                </div>
              </div>
            </div>
          </div>

          {/* Copyright Section */}
          <div className={`mt-6 sm:mt-8 pt-4 sm:pt-6 border-t ${currentTheme.border} text-center`}>
            <p className={`${currentTheme.textSecondary} text-xs sm:text-sm`} style={customStyles.copyright}>
              Construindo uma comunidade onde a troca é a nova moeda.
            </p>
            <p className={`${currentTheme.textSecondary} text-xs sm:text-sm`} style={customStyles.copyright}>
              © {new Date().getFullYear()} Escambo Digital. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
